<template>
  <div id="app">
    <!-- 只有当前路由不是登录页时才显示菜单 -->
    <MenuBar 
      v-if="$route.path !== '/login'"
      @open-search-dialog="showSearchDialog"
      :class="{ 
        'text-white': $route.path === '/', 
        'mistake': $route.path !== '/' 
    }"/>
    <router-view />
    <!-- 悬浮按钮组件 -->
    <FloatingActions v-if="$route.path !== '/login'" :SpgData="SpgData"/>
    <!-- 只有当前路由不是登录页时才显示页脚 -->
    <FooterBar v-if="$route.path !== '/login'" :SpgData="SpgData" :QRcode="SpgData.QRcode" :adminLogin="SpgData.adminLogin"/>


    <!-- 搜索弹窗（实现全屏居中） -->
    <el-dialog
      title="站内搜索"
      :visible.sync="searchDialogVisible"
      width="80%"
      :close-on-click-modal="true"
      @close="handleSearchClose"
      class="search-dialog"
    >
      <!-- 弹窗内部内容 -->
      <div class="search-wrapper">
        <div class="search-container">
          <!-- 大搜索框 -->
          <el-input
            v-model="searchKeyword"
            placeholder="请输入搜索内容..."
            size="large"
            @keyup.enter.native="handleSearch"
            style="width: 100%; max-width: 800px; margin-bottom: 20px;"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="suffix"
              type="primary"
              @click="handleSearch"
            >
              搜索
            </el-button>
          </el-input>
          
          <!-- 热门搜索 -->
          <div class="search-hot" v-if="hotKeywords.length > 0">
            <span class="hot-title">热门搜索：</span>
            <el-tag size="medium"
              v-for="(keyword, index) in hotKeywords"
              :key="index"
              @click="searchKeyword = keyword; handleSearch()"
              closable
              style="margin: 0 5px 5px 0;"
            >
              {{ keyword }}
            </el-tag>
          </div>
        </div>
      </div>

      <div class="">
        <img style="width: 20%;margin-top: 0px;mix-blend-mode: multiply;min-width: 200px;" src="https://7765-web-2gpx1p8e8259ddd9-1253923329.tcb.qcloud.la/tcb_upload/1770885569324_nb3gh7f3.png"/>
        <p>暂无数据~</p>
      </div>

      <!-- 弹窗底部按钮 -->
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="searchDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSearch">确认搜索</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data(){
    return {
      // 控制搜索弹窗显示/隐藏
      searchDialogVisible: false,
      // 搜索关键词
      searchKeyword: "",
      // 热门搜索关键词
      hotKeywords: ["富锶天然水", "三皮罐凉茶", "三皮罐集团", "楚天城", "云庭", "壹号院"],
      SpgData:{},
      // PosterInfo: { 活动海报弹窗
      //   start: true,
      //   dynamicId: "688aea9d9bf5cd01d7ae8f8c0",
      //   posterImage: "http://www.3pg.cn/static/%E6%B5%B7%E6%8A%A503.1f799b3f.jpg"
      // }
    }
  },
  created() {
    // this.getSPGData()
    this.getSpgWebAllData()
  },
  mounted() {
    // console.log('$i18n 实例:', this.$i18n); 
    // 确保 DOM 渲染完成后初始化 Wow
    this.$nextTick(() => {
      this.$wow.init()
    })
    // 初始化时，将 html 的 lang 设置为当前 i18n 语言
    document.documentElement.lang = this.$i18n.locale;

    // 监听语言切换事件，实时同步
    // this.$i18n.$on('languageChanged', (newLang) => {
    //   document.documentElement.lang = newLang;
    // });
  },
  methods:{
    async getSpgWebAllData() {
      try {
        const res = await this.$db.collection('SPG-WEB-SpgData').get()
        this.SpgData = res.data[0]
        // console.log('SpgData', res.data[0])
      } catch (err) {
        console.error('SpgData数据请求失败：', err)
        this.$message?.error('SpgData数据请求失败')
      }
    },
    // 请求获取数据信息
    getSPGData() {
      const query = new this.$AV.Query("SPG");
      query.get("688aea9d9bf5cd01d7ae8f8c")
      .then((SpgData) => {
        this.SpgData = JSON.parse(SpgData._hashedJSON.SpgData)
        // console.log(this.SpgData)
      })
      .catch((err) => {
        console.error(err.message)
      });
    },
    // 父组件接收子组件事件，打开弹窗
    showSearchDialog() {
      this.searchDialogVisible = true;
      // 每次打开弹窗清空搜索框
      this.searchKeyword = "";
    },
    // 处理搜索逻辑（父组件中执行）
    handleSearch() {
      if (!this.searchKeyword.trim()) {
        this.$message.warning("请输入搜索内容！");
        return;
      }

      // 这里写实际的搜索逻辑（调用接口/过滤数据等）
      console.log("父组件执行搜索，关键词：", this.searchKeyword);
      this.$message.success(`正在搜索：${this.searchKeyword}`);
    },
    // 关闭弹窗时清空搜索框
    handleSearchClose() {
      this.searchKeyword = "";
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* padding-top: 80px; */
  box-sizing:border-box;
}
/* 在全局样式中定义首页导航栏的白色字体样式 */
.MenuBar.text-white .nav a {
  color: white;
}
.wow {
  visibility: hidden;
}
/* 如果MenuBar内部有子元素需要单独设置 */
.text-white .nav a,
.text-white .menu-item {
  color: white;
}


/* 核心：弹窗全屏居中样式 */
.search-dialog {
  ::v-deep .el-dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0; /* 移除默认margin，避免影响居中 */
  }

  /* 弹窗内容区样式（内部内容居中） */
  ::v-deep .el-dialog__body {
    padding: 40px 20px;
    margin: 0;
    height: 200px; /* 内容区高度，可调整 */
    display: flex;
    justify-content: center; /* 内部水平居中 */
    align-items: center; /* 内部垂直居中 */
    border: none;
  }
}

</style>
<style scoped>
::v-deep .el-dialog{
  border-radius: 12px !important;
}
::v-deep .el-tag{
  background-color: #e600131e;
  border-color: #e6001336;
  color: #E60012;
}
::v-deep .el-tag {
  cursor: pointer;
}
::v-deep .el-input__suffix{
  right: 0;
}
::v-deep el-input__inner{
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-button{
  border-radius: 0px 4px 4px 0px;
  padding: 12px 40px;
}
::v-deep .el-tag .el-tag__close{
  color: #E60012;
}
::v-deep  .el-tag .el-tag__close:hover{
  background-color: #E60012;
}
/* 搜索外层容器 */
.search-wrapper {
  width: 100%;
  text-align: center;
}

/* 搜索容器样式 */
.search-container {
  padding: 10px 0;
  width: 100%;
}

/* 热门搜索样式 */
.search-hot {
  margin-top: 10px;
  text-align: center; /* 热门搜索标签居中 */
}

.hot-title {
  font-size: 14px;
  color: #666;
  margin-right: 10px;
}

/* 弹窗底部按钮区样式 */
::v-deep .dialog-footer {
  text-align: center; /* 按钮也居中 */
}
</style>